import { render } from "./SheetImagesAdminView.vue?vue&type=template&id=471251fe&scoped=true"
import script from "./SheetImagesAdminView.vue?vue&type=script&lang=js"
export * from "./SheetImagesAdminView.vue?vue&type=script&lang=js"

import "./SheetImagesAdminView.vue?vue&type=style&index=0&id=471251fe&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471251fe"]])

export default __exports__